module.exports = __webpack_public_path__ + "img/nofile.426e7a8c.svg";